import { Popconfirm } from 'antd';
import { Form, Input, Button, message } from '@maxtropy/components';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import Title from '../Title';
import { apiV2MobileRemoteConfigButtonPost, apiV2MobileRemoteGetConfigPost } from '@maxtropy/device-customer-apis-v2';
import { Spin } from 'antd';

const ButtonConfig = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [initLoading, setInitLoading] = useState(true);

  //保存
  const onFinish = (values: any) => {
    console.log('Received values of form:', values);
    apiV2MobileRemoteConfigButtonPost({ buttons: values.buttons }).then(() => {
      message.success('按钮配置保存成功');
      navigate('/ip/configuration');
    });
  };

  //获取按钮配置
  useEffect(() => {
    apiV2MobileRemoteGetConfigPost({}).then(res => {
      form.setFieldsValue({
        buttons: res.buttonConfigs?.map((item: any) => ({ buttonName: item.buttonName, commandUrl: item.commandUrl })),
      });
      setInitLoading(false);
    });
  }, []);
  return (
    <div className={styles.buttonConfig}>
      <Title>按钮配置</Title>
      <div className={styles.ButtonActive} onClick={() => navigate('/ip/configuration')}>
        返回
      </div>
      <div className={styles.formContainer}>
        <Spin spinning={initLoading}>
          <Form form={form} initialValues={{ buttons: [] }} onFinish={onFinish}>
            <Form.List name="buttons">
              {(fields, { add, remove }) => (
                <>
                  <div className={styles.buttonConfigHeader}>
                    <div className={`${styles.headerCol} ${styles.index}`}>序号</div>
                    <div className={`${styles.headerCol} ${styles.name}`}>按钮名称</div>
                    <div className={`${styles.headerCol} ${styles.url}`}>跳转地址/命令</div>
                    <div className={`${styles.headerCol} ${styles.action}`}>操作</div>
                  </div>

                  {fields.map((field, index) => (
                    <div key={field.key} className={styles.buttonConfigRow}>
                      <div className={`${styles.rowCol} ${styles.index}`}>{index + 1}</div>
                      <div className={`${styles.rowCol} ${styles.name}`}>
                        <Form.Item
                          name={[field.name, 'buttonName']}
                          rules={[{ required: true, message: '请输入按钮名称' }]}
                        >
                          <Input placeholder="请输入" />
                        </Form.Item>
                      </div>
                      <div className={`${styles.rowCol} ${styles.url}`}>
                        <Form.Item
                          name={[field.name, 'commandUrl']}
                          rules={[{ required: true, message: '请输入跳转地址/命令' }]}
                        >
                          <Input placeholder="请输入" />
                        </Form.Item>
                      </div>
                      <div className={`${styles.rowCol} ${styles.action}`}>
                        <Popconfirm title="确定要删除这一行吗？" onConfirm={() => remove(index)}>
                          <div className={styles.deleteButton}>删除</div>
                        </Popconfirm>
                      </div>
                    </div>
                  ))}

                  <div className={styles.addButtonWrapper}>
                    <div onClick={() => add()} className={styles.addButton}>
                      + 添加按钮
                    </div>
                  </div>
                  <Button onClick={() => form.submit()} type="primary">
                    保存并返回按钮列表
                  </Button>
                </>
              )}
            </Form.List>
          </Form>
        </Spin>
      </div>
    </div>
  );
};

export default ButtonConfig;
